import React from 'react';

interface YouTubeIframeProps {
    link: string;
}

export const YouTubeIframe = ({ link }: YouTubeIframeProps) => {
    const youtubeId = link.slice(-11);
    return (
        <div className="youtube-wrapper">
            <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${youtubeId}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ border: 'none' }}
            />
        </div>
    );
};
